import { render, staticRenderFns } from "./TimePieBlock.vue?vue&type=template&id=1c32b751&scoped=true&"
import script from "./TimePieBlock.vue?vue&type=script&lang=js&"
export * from "./TimePieBlock.vue?vue&type=script&lang=js&"
import style0 from "./TimePieBlock.vue?vue&type=style&index=0&id=1c32b751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32b751",
  null
  
)

export default component.exports